import React from 'react';
import { Box, Typography } from '@material-ui/core';
import NewConsultationForm from './NewConsultationForm';
import UpcomingConsultationRequests from './UpcomingConsultationRequests';
import { useTranslation } from '../../hooks/useTranslation';
import usePgeQuery from '../../hooks/usePgeQuery';
import {
  ConsultationStatus,
  EnergyConsultationDetails,
  QueryGetEnergyConsultationRequestsArgs,
} from '../../__generated__/pge-types';
import { getEnergyConsultationRequests } from './queries';
import Backdrop from '../backdrop/Backdrop';
import useHasNonResidentialAccounts from '../../hooks/useHasNonResidentialAccounts';

const EnergyConsultation: React.FC = () => {
  const { t } = useTranslation();
  const {
    hasNonResidentialAccounts,
    loading: accountsLoading,
  } = useHasNonResidentialAccounts();

  const { loading, data, called } = usePgeQuery<
    {
      getEnergyConsultationRequests: Array<EnergyConsultationDetails>;
    },
    QueryGetEnergyConsultationRequestsArgs
  >(getEnergyConsultationRequests, {
    variables: {
      filterBy: {
        status: [ConsultationStatus.Confirmed, ConsultationStatus.Pending],
      },
    },
    errorPolicy: 'all',
    skip: accountsLoading || !hasNonResidentialAccounts,
  });

  const consultations = data?.getEnergyConsultationRequests;

  if (accountsLoading) {
    return <Backdrop forceOpen />;
  }

  return (
    <Box>
      {loading && <Backdrop forceOpen />}

      <Typography variant="h2" gutterBottom>
        {t('ENERGY_CONSULTATION_TITLE')}
      </Typography>

      {!hasNonResidentialAccounts ? (
        <Typography color="textSecondary" variant="body2">
          {t('FEATURE_NOT_AVAILABLE_FOR_RES')}
        </Typography>
      ) : (
        <>
          <Typography color="textSecondary" variant="body2">
            {t('ENERGY_CONSULTATION_SUBTITLE')}
          </Typography>

          <UpcomingConsultationRequests consultations={consultations ?? []} />

          {called && !loading && (
            <NewConsultationForm
              defaultExpanded={consultations?.length === 0}
            />
          )}
        </>
      )}
    </Box>
  );
};

export default EnergyConsultation;
